module.exports = __webpack_public_path__ + "img/ИФ-1(А)-051-m.458cc1b5.png";